<div class="pagina-web">

  <div class="barra-navegacion">
    <app-barra-navegacion (newItemEvent)="scroll($event)"></app-barra-navegacion>
  </div>

  <div #portada class="portada">
    <app-portada></app-portada>
  </div>

  <div #somos class="quienes-somos">
    <app-quienes-somos></app-quienes-somos>
  </div>

  <div class="primer-separador">
    <app-primer-separador></app-primer-separador>
  </div>

  <div #historia class="nuestra-historia">
    <app-nuestra-historia></app-nuestra-historia>
  </div>

  <div class="segundo-separador">
    <app-segundo-separador></app-segundo-separador>
  </div>

  <div #trabajo class="nuestro-trabajo">
    <app-nuestro-trabajo></app-nuestro-trabajo>
  </div>

  <div class="tercer-separador">
    <app-tercer-separador></app-tercer-separador>
  </div>

  <div #ayuda class="ayuda">
    <app-ayuda></app-ayuda>
  </div>

  <div class="cuarto-separador">
    <app-cuarto-separador></app-cuarto-separador>
  </div>

  <div #contacto class="contacto">
    <app-contacto></app-contacto>
  </div>
</div>

<div class="pie-pagina">
  <app-pie-pagina></app-pie-pagina>
</div>
